// Outline icons, 24px grid, 1.5px stroke, currentColor. One Icon() entry point.
// koboyo is not connected in this workspace (no key); glyphs are drawn to the brand's thin-stroke spec.
const P: Record<string, string> = {
  check: "M20 12a8 8 0 1 1-16 0a8 8 0 1 1 16 0zM8.5 12.2l2.4 2.4 4.8-4.9",
  chevron: "M9.5 6l6 6-6 6",
  back: "M14.5 6l-6 6 6 6",
  close: "M6.5 6.5l11 11M17.5 6.5l-11 11",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  alert: "M20 12a8 8 0 1 1-16 0a8 8 0 1 1 16 0zM12 7.8v5M12 15.8v.4",
  calendar: "M6 5.5h12a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2zM4 10h16M8.5 3.5v4M15.5 3.5v4",
  pin: "M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11zM14.3 10a2.3 2.3 0 1 1-4.6 0a2.3 2.3 0 1 1 4.6 0z",
  cancelled: "M20 12a8 8 0 1 1-16 0a8 8 0 1 1 16 0zM9.5 9.5l5 5M14.5 9.5l-5 5",
  refresh: "M19 12a7 7 0 1 1-2.05-4.95M19 5v4h-4",
};

export function Icon(name: keyof typeof P | string, cls = "ic"): string {
  return `<svg class="${cls}" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="${P[name] ?? ""}"/></svg>`;
}
